module.exports = __webpack_public_path__ + "static/media/M.c7ff5170.jpg";